import { Button } from "@govlaunch/web";
import React from "react";
import { FormattedMessage } from "react-intl";

interface IFiltersToggleButtonProps {
  onClick: any;
  active?: boolean;
}

export default function FiltersToggleButton({ onClick, active }: IFiltersToggleButtonProps) {
  return (
    <Button
      variant={!active ? "primary" : "secondary"}
      size="sm"
      onClick={onClick}
      leftIcon={props => (
        <svg width="17" height="10" viewBox="0 0 17 10" fill="none" {...props}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0714 2H0.0714417V0H16.0714V2ZM13.6713 6H2.47134V4H13.6713V6ZM4.87125 10H11.2712V8H4.87125V10Z"
            fill="currentColor"
          />
        </svg>
      )}
    >
      <FormattedMessage defaultMessage="Filters" id="zSOvI0" />
    </Button>
  );
}
